
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { LITE_PACKAGE_IDS } from "functions/src/Subscriptions/packageIds";

import { tools } from "@/mixins/tools";
import MyTeamUsersSort from "./my-team-users-sort.vue";
import MyTeamNumericSort from "./my-team-numeric-sort.vue";
import MyTeamAlphaSort from "./my-team-alpha-sort .vue";
import PackageIcon from "../common/PackageIcon.vue";
import { productVisual, productVisualId } from "../common/productVisuals";

export default defineComponent({
  name: "my-team-table",
  components: {
    MyTeamUsersSort,
    MyTeamNumericSort,
    MyTeamAlphaSort,
    PackageIcon,
  },
  emits: ["updateSortConfiguration"],
  computed: {
    ...mapGetters("ranks", ["rankName", "rankIconClass"]),
    ...mapGetters("myTeam", {
      isLoading: "getIsLoading",
      teamMembers: "getDisplayedTeam",
      getColumnSortDirection: "getColumnSortDirection",
    }),
  },
  methods: {
    /** ¿Es un Lite? Las dos generaciones de etiqueta cuentan. */
    isLitePackage(currentPackage: string): boolean {
      return LITE_PACKAGE_IDS.includes(currentPackage);
    },
    // Cómo se ve un paquete —color, icono y nombre— ya no se decide en esta
    // tabla: se pregunta. Los dos `switch` que había aquí (uno para el icono,
    // otro para el rótulo) traducían a mano las dos generaciones de etiqueta y
    // se quedaban con lo que hubiera a mano en FontAwesome; ahora la traducción
    // y el aspecto salen de `productVisuals`, que es el mismo sitio del que los
    // sacan la tienda, los canales y el unilevel.
    //
    // El caso «no lo reconozco» también cambia: antes era una cruz ROJA, que se
    // lee como un error del socio, y un rótulo vacío. Ahora es la pastilla gris
    // de «sin paquete», que es lo que de verdad pasa.
    packageBadgeClass(currentPackage: string): string {
      return `pkg-subtle-${productVisualId(currentPackage)}`;
    },
    packageLabel(currentPackage: string): string {
      return productVisual(currentPackage).shortLabel;
    },
    unilevelSideLabel(unilevelSide: "left" | "right" | string) {
      switch (unilevelSide) {
        case "left":
          return "Izquierdo";
        case "right":
          return "Derecho";
        default:
          return "";
      }
    },
    // La clase de color va PEGADA a la del icono y no en un `:class` aparte
    // para que el caso «no sé de qué lado es» siga saliendo sin icono y sin
    // color, en una sola decisión y no en dos que puedan discrepar.
    unilevelSideIconClass(unilevelSide: "left" | "right" | string) {
      switch (unilevelSide) {
        case "left":
          return "fas fa-arrow-alt-circle-left fa-lg side-icon side-icon-left";
        case "right":
          return "fas fa-arrow-alt-circle-right fa-lg side-icon side-icon-right";
        default:
          return "";
      }
    },
    formatDateTimezone(milliseconds: number): string {
      return milliseconds == 0
        ? "-"
        : tools.methods.formatDateTimezone(milliseconds);
    },
    daysLeftClass(daysLeft: number): string {
      console.log();
      if (daysLeft <= 5) {
        return "bg-danger";
      } else if (daysLeft <= 10) {
        return "bg-warning";
      } else {
        return "bg-success";
      }
    },
    showUserTeam(username: string) {
      this.$store.dispatch("myTeam/doGetTeamForUser", {
        username: username,
        forceUpdate: false,
      });
    },
    updateSortConfiguration(column: string, direction: "asc" | "desc") {
      this.$emit("updateSortConfiguration", column, direction);
    },
  },
});
